import React from 'react';
import { CONTACT, LOGOS } from '../mock';

export default function Footer() {
  return (
    <footer className="bg-[#132a44] text-white pt-16 pb-8">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="bg-white rounded-xl p-4 inline-block">
              <img src={LOGOS.sticker} alt="Inżynieria Elektryczna Adrian Nowak - kontakt" className="w-full max-w-[340px] h-auto block" />
            </div>
            <p className="mt-6 text-[14px] leading-relaxed text-white/70 max-w-md">
              Inżynieria Elektryczna Adrian Nowak, kompleksowe usługi inżynieryjne dla przemysłu, budownictwa i inwestorów. Projektowanie, automatyka, kierowanie robotami oraz nadzór elektryczny.
            </p>
          </div>

          <div className="md:col-span-4">
            <div className="text-[11px] font-semibold tracking-[0.2em] text-white/50 mb-4">NAWIGACJA</div>
            <div className="grid grid-cols-2 gap-y-2 text-[14px]">
              <a href="#automatyka" className="text-white/80 hover:text-[#f5c518] transition-colors">Automatyka</a>
              <a href="#nadzor" className="text-white/80 hover:text-[#f5c518] transition-colors">Nadzór</a>
              <a href="#projektowanie" className="text-white/80 hover:text-[#f5c518] transition-colors">Projektowanie</a>
              <a href="#obszar" className="text-white/80 hover:text-[#f5c518] transition-colors">Obszar działania</a>
              <a href="#o-firmie" className="text-white/80 hover:text-[#f5c518] transition-colors">O firmie</a>
              <a href="#kontakt" className="text-white/80 hover:text-[#f5c518] transition-colors">Kontakt</a>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] font-semibold tracking-[0.2em] text-white/50 mb-4">KONTAKT</div>
            <div className="font-heading font-bold text-[20px]">{CONTACT.phone}</div>
            <div className="text-[14px] text-white/80 mt-1">{CONTACT.email}</div>
            <a href={CONTACT.google} target="_blank" rel="noopener noreferrer" className="mt-3 inline-block text-[14px] text-[#f5c518] font-semibold">Wizytówka Google</a>
            <div className="mt-4 text-[13px] text-white/60 leading-relaxed">
              Klonowa 3<br />64-140 Włoszakowice
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between gap-3 text-[12px] text-white/50">
          <div>
            © 2026 Inżynieria Elektryczna Adrian Nowak. Wszelkie prawa zastrzeżone.<br />
            Power by <a href="https://webcreato.pl/" target="_blank" rel="noopener noreferrer" className="text-[#f5c518] hover:underline">webcreato.pl</a>
          </div>
          <div>Klonowa 3, 64-140 Włoszakowice</div>
        </div>
      </div>
    </footer>
  );
}
